var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagBasqueCountry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_14977)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.135498 18.0869C0.507748 20.944 1.63412 23.5637 3.30769 25.7409L11.8261 18.0869H0.135498Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9135 31.8647V20.1741L6.25952 28.6925C8.43683 30.3661 11.0565 31.4925 13.9135 31.8647Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9135 0.135498C11.0565 0.507748 8.43683 1.63412 6.25952 3.30769L13.9135 11.8262V0.135498Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.135498 13.913H11.8261L3.30762 6.25903C1.63406 8.43628 0.507686 11.056 0.135498 13.913Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0867 0.135498V11.8261L25.7408 3.30769C23.5635 1.63425 20.9438 0.507686 18.0867 0.135498Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8642 13.9131C31.492 11.056 30.3656 8.43635 28.692 6.25903L20.1736 13.9131H31.8642Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1736 18.0869L28.6921 25.741C30.3656 23.5637 31.492 20.944 31.8643 18.0869H20.1736Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0867 31.8647C20.9437 31.4924 23.5635 30.3661 25.7407 28.6924L18.0867 20.1741V31.8647Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6939 25.7423L18.9518 16.0001L18.9517 16L28.6939 6.25777C28.2738 5.71177 27.8141 5.18652 27.314 4.68627C26.8139 4.18615 26.2886 3.72646 25.7425 3.3064L16.0003 13.0486H16.0003L6.25808 3.3064C5.71208 3.72652 5.18677 4.18608 4.68652 4.68627C4.18639 5.18652 3.7267 5.71177 3.30664 6.25783L13.0488 16L13.0489 16L3.3067 25.7423C3.72683 26.2882 4.18645 26.8135 4.68658 27.3138C5.18677 27.8139 5.71208 28.2736 6.25814 28.6936L16.0003 18.9515L25.7425 28.6936C26.2885 28.2735 26.8138 27.8139 27.314 27.3138C27.8142 26.8135 28.2738 26.2882 28.6939 25.7423Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0869 31.8646V18.0871V18.087H31.8646C31.9536 17.4038 32 16.7073 32 16C32 15.2928 31.9536 14.5963 31.8646 13.9131H18.0871L18.087 13.9131V0.1355C17.4039 0.0465625 16.7074 0 16 0C15.2927 6.25e-05 14.5962 0.0465625 13.9131 0.1355L13.9131 13.9129V13.9131H0.1355C0.0465 14.5962 0 15.2927 0 16C6.25e-05 16.7074 0.0465 17.4038 0.1355 18.0869H13.913L13.9131 31.8646C14.5962 31.9535 15.2926 32 16 32C16.7074 32 17.4039 31.9535 18.0869 31.8646Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_14977"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagBasqueCountry);
export default __webpack_public_path__ + "static/media/flag_basque_country.521d783c1ad6cc67575e739d44fdb4dd.svg";
export { ForwardRef as ReactComponent };